import { overlay } from "overlay-kit";

import { AddSectionModal } from "./AddSectionModal";
import { CopyMoveSectionModal } from "./CopyMoveSectionModal";

import { SectionType } from "components/server-types";
import { t } from "i18n/i18n";
import { Dialog } from "mds/components/Dialog";

type ShowAddSectionModalOptions = {
  defaultCourseId?: string | null;
  defaultTermId?: string | null;
  defaultTemplateId?: string | null;
  eventName?: string;
};

export const showAddSectionModal = ({
  defaultCourseId,
  defaultTermId,
  defaultTemplateId,
  eventName,
}: ShowAddSectionModalOptions) =>
  overlay.open(({ isOpen, unmount }) => (
    <Dialog open={isOpen} title={t("home.add_section_modal.add_section_title")} onClose={unmount}>
      <AddSectionModal
        defaultCourseId={defaultCourseId}
        defaultTemplateId={defaultTemplateId}
        defaultTermId={defaultTermId}
        eventName={eventName}
        onClose={unmount}
      />
    </Dialog>
  ));

type ShowCopySectionModalOptions = {
  section: SectionType;
  onCopyTo: (sectionId: string, courseId?: string, termId?: string) => void;
};

export const showCopySectionModal = ({ section, onCopyTo }: ShowCopySectionModalOptions) =>
  overlay.open(({ isOpen, unmount }) => (
    <Dialog
      description={t("sidebar_options_menu.copy_section_description")}
      open={isOpen}
      title={t("sidebar_options_menu.copy_section_to")}
      onClose={unmount}
    >
      <CopyMoveSectionModal
        defaultCourseId={section.course_id}
        defaultTermId={section.term_id}
        mode="copy"
        onClose={unmount}
        onSubmit={(courseId, termId) => {
          onCopyTo(section.id, courseId, termId);
          unmount();
        }}
      />
    </Dialog>
  ));

type ShowMoveSectionModalOptions = {
  section: SectionType;
  onMoveTo: (courseId: string, termId: string) => void;
};

export const showMoveSectionModal = ({ section, onMoveTo }: ShowMoveSectionModalOptions) =>
  overlay.open(({ isOpen, unmount }) => (
    <Dialog
      description={t("sidebar_options_menu.move_section_description")}
      open={isOpen}
      title={t("sidebar_options_menu.move_section_to")}
      onClose={unmount}
    >
      <CopyMoveSectionModal
        defaultCourseId={section.course_id}
        defaultTermId={section.term_id}
        mode="move"
        onClose={unmount}
        onSubmit={(courseId, termId) => {
          onMoveTo(courseId, termId);
          unmount();
        }}
      />
    </Dialog>
  ));
